import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { ListLoadingState } from "../../components/ListLoadingState";
import { useGetWorkerVisitLockStatus } from "../useGetWorkerVisitLockStatus";
import { useVisitsListData } from "../useVisitsListData";
import { InHomeOpenVisitCard } from "./Card";
import { InHomeOpenVisitsEmptyState } from "./EmptyState";
import { InHomeLockBanner } from "./InHomeLockBanner";

export function InHomeOpenVisitsList() {
  const { userId: workerId } = useDefinedWorker();

  const {
    visits,
    caseIdToPatientMap,
    caseIdToWorkplaceNameMap,
    caseIdToWorkplaceIdMap,
    caseIdToSpecialtiesMap,
    isVisitsLoading,
    isVisitsSuccess,
  } = useVisitsListData({ booked: "false" });

  const { data: lockResponse } = useGetWorkerVisitLockStatus(workerId);
  const lockedByWorkplaceId = lockResponse?.data?.attributes.lockedByWorkplaceId;

  if (isVisitsLoading) {
    return (
      <ListLoadingState
        texts={[
          "Finding you the best-paying visits nearby",
          "Analyzing visit opportunities just for you",
          "Your perfect visit is just a moment away",
          "Crunching the numbers to maximize your earnings",
          "Searching high and low for the best visits nearby",
          "We are on it - finding visits that matter most",
          "Unlocking your next great opportunity",
        ]}
      />
    );
  }

  if (isVisitsSuccess && visits.length === 0) {
    return isDefined(lockedByWorkplaceId) ? (
      <InHomeLockBanner lockedByWorkplaceId={lockedByWorkplaceId} />
    ) : (
      <InHomeOpenVisitsEmptyState />
    );
  }

  return (
    <Stack spacing={5}>
      {isDefined(lockedByWorkplaceId) && (
        <InHomeLockBanner lockedByWorkplaceId={lockedByWorkplaceId} />
      )}
      {visits.map((visit) => {
        const patient = caseIdToPatientMap.get(visit.attributes.caseId);
        const specialties = caseIdToSpecialtiesMap.get(visit.attributes.caseId);
        const workplaceName = caseIdToWorkplaceNameMap.get(visit.attributes.caseId);
        const workplaceId = caseIdToWorkplaceIdMap.get(visit.attributes.caseId);

        return (
          <InHomeOpenVisitCard
            key={visit.id}
            visit={visit}
            patient={patient}
            specialties={specialties ?? []}
            workplaceName={workplaceName ?? ""}
            workplaceId={workplaceId ?? ""}
          />
        );
      })}
    </Stack>
  );
}
